import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  topUpInputField: {
    marginBottom: theme.spacing(15),
  },
  nextButton: {
    padding: theme.spacing(7.5, 29.5),
    '&.Mui-disabled': {
      backgroundColor: '#ABAFB3',
      color: '#fff',
    },
  },
  nextButtonLabel: {
    textTransform: 'capitalize',
    fontSize: theme.spacing(9),
    lineHeight: '27px',
  },
}));
